import {Component, Input, ViewEncapsulation, OnInit} from '@angular/core';
import {User} from '../../../../models/User';

@Component({
  selector: 'app-team-user',
  templateUrl: './team-user.component.html',
  styleUrls: ['./team-user.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class TeamUserComponent {
  
  @Input() user: User;
  
  constructor() {
  }
}
